import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Home, Store, Info, Shield, Mail } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';

const MobileNav = () => {
  const [open, setOpen] = useState(false);

  const menuItems = [
    { name: 'Home', path: '/', icon: Home },
    { name: 'Stores', path: '/stores', icon: Store },
    { name: 'About Us', path: '/about', icon: Info },
    { name: 'Privacy Policy', path: '/privacy', icon: Shield },
    { name: 'Contact Us', path: '/contact', icon: Mail },
  ];

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild className="lg:hidden">
        <button className="p-2 hover:bg-slate-100 rounded-lg transition-colors">
          <Menu className="w-6 h-6 text-slate-700" />
        </button>
      </SheetTrigger>
      <SheetContent side="left" className="w-80 p-0">
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="p-6 border-b border-slate-200 bg-slate-900">
            <Link to="/" onClick={() => setOpen(false)} className="flex items-center space-x-2">
              <img 
                src="https://customer-assets.emergentagent.com/job_discount-finder-55/artifacts/kl5rg4yh_ic_launcher.png" 
                alt="Peterhahn Fashion Coupon Club" 
                className="w-10 h-10 object-contain"
              />
              <span className="text-xl font-bold text-white">
                Peterhahn Fashion Coupon Club
              </span>
            </Link>
          </div>

          {/* Menu Items */}
          <nav className="flex-1 p-4">
            <ul className="space-y-2">
              {menuItems.map((item) => {
                const Icon = item.icon;
                return (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      onClick={() => setOpen(false)}
                      className="flex items-center space-x-3 p-3 rounded-lg hover:bg-slate-100 transition-colors group"
                    >
                      <Icon className="w-5 h-5 text-slate-600 group-hover:text-slate-900" />
                      <span className="text-slate-700 group-hover:text-slate-900 font-medium">
                        {item.name}
                      </span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>

          {/* Footer */}
          <div className="p-6 border-t border-slate-200 bg-slate-50">
            <p className="text-sm text-slate-600 text-center">
              © 2025 Peterhahn Fashion Coupon Club
            </p>
            <p className="text-xs text-slate-500 text-center mt-1">
              Save money with verified coupons
            </p>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileNav;
